import { useState, useEffect } from "react";
import modalimg from './img/modal.png';

const Creneau = () => {
  const [lastName, setLastName] = useState('');
  const [firstName, setFirstName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showIntroModal, setShowIntroModal] = useState(false); // introduction modal

  useEffect(() => {
    setShowIntroModal(true);
  }, []);

  const handleReserve = (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!firstName || !lastName || !email || !phoneNumber) {
      setError('Tous les champs sont requis.');
      return;
    }

    const raw = localStorage.getItem("reservations");
    let storedArr;
    try {
      const parsed = JSON.parse(raw);
      storedArr = Array.isArray(parsed) ? parsed : [];
    } catch {
      storedArr = [];
    }

    const newArr = [...storedArr, { firstName, lastName, email, phoneNumber }];
    localStorage.setItem("reservations", JSON.stringify(newArr));
    setSuccess("Rendez-vous réservé avec succès !");
    setShowModal(true);

    // CORRECTION: Envoi avec FormData pour compatibilité avec Apps Script
    const formData = new FormData();
    formData.append('firstName', firstName);
    formData.append('lastName', lastName);
    formData.append('email', email);
    formData.append('phoneNumber', phoneNumber);

    fetch("https://script.google.com/macros/s/AKfycbwlQ5nc4gcq0uj-QAajc8z3a0557q-cxtc9IaCGDUt1RAYjWKVceYkSaNVWxI7Zv15DSQ/exec", {
      method: "POST",
      body: formData,
      mode: 'no-cors'
    })
    .then(() => {
      console.log("Données envoyées à Google Sheets");
    })
    .catch(err => console.error("Erreur réseau:", err));

    // Fermer le modal après 5 secondes
    setTimeout(() => setShowModal(false), 5000);

    // Réinitialise les champs
    setFirstName('');
    setLastName('');
    setEmail('');
    setPhoneNumber('');
    setSuccess('');
  };

  return (
    <div className="max-w-xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-center text-black dark:text-white">Prendre un rendez-vous</h1>

      <form onSubmit={handleReserve} className="grid gap-4 lg:gap-6">
          {/* Nom & Prénom */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
            <div>
              <label htmlFor="last-name" className="block mb-2 text-sm text-gray-700 font-bold dark:text-white">Nom</label>
              <input
                id="last-name"
                type="text"
                value={lastName}
                onChange={e => setLastName(e.target.value.toUpperCase())}
                className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 bg-gray-500"
              />
            </div>
            <div>
              <label htmlFor="first-name" className="block mb-2 text-sm text-gray-700 font-bold dark:text-white">Prénom</label>
              <input
                id="first-name"
                type="text"
                value={firstName}
                onChange={e => setFirstName(e.target.value)}
                className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 bg-gray-500"
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <label htmlFor="email" className="block mb-2 text-sm text-gray-700 font-bold dark:text-white">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600  bg-gray-500"
            />
          </div>

          {/* Téléphone */}
          <div>
            <label htmlFor="phone" className="block mb-2 text-sm text-gray-700 font-bold dark:text-white">Téléphone</label>
            <input
              id="phone"
              type="tel"
              value={phoneNumber}
              onChange={e => setPhoneNumber(e.target.value)}
              className="py-2.5 sm:py-3 px-4 block w-full border-gray-200 rounded-lg sm:text-sm focus:border-blue-500 focus:ring-blue-500 dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600 bg-gray-500"
            />
          </div>

          {/* Erreurs / Succès */}
          {error && <p className="text-red-600 mt-2">{error}</p>}
          {success && <p className="text-green-600 mt-2">{success}</p>}

          {/* Bouton */}
          <div className="mt-6 grid">
            <button
              type="submit"
              className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-xl font-bold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-hidden focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
            >
              Réserver
            </button>
          </div>
      </form>

      {showModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded shadow-lg">
            <p className="text-black">Vous allez recevoir un email de confirmation.</p>
          </div>
        </div>
      )}
      {/* Modale d'introduction - Simplifiée sans dépendances HSOverlay */}
      {showIntroModal && (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
          <div className="bg-white dark:bg-neutral-900 rounded-xl shadow-2xl max-w-4xl w-full m-3 max-h-[calc(100vh-56px)] flex flex-col">
            {/* Header */}
            <div className="flex justify-between items-center py-3 px-4 border-b border-gray-200 dark:border-neutral-800">
              <h3 className="font-bold text-gray-800 dark:text-neutral-200">
                Bienvenue !
              </h3>
              <button
                type="button"
                className="size-8 inline-flex justify-center items-center gap-x-2 rounded-full border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-hidden focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-700 dark:hover:bg-neutral-600 dark:text-neutral-400 dark:focus:bg-neutral-600"
                aria-label="Close"
                onClick={() => setShowIntroModal(false)}
              >
                <span className="sr-only">Fermer</span>
                <svg
                  className="shrink-0 size-4"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 6 6 18" />
                  <path d="m6 6 12 12" />
                </svg>
              </button>
            </div>
      
            {/* Content */}
            <div className="p-4 overflow-y-auto space-y-4 text-gray-700 dark:text-neutral-300">
              <img
                src={modalimg}
                alt="Illustration"
                className="rounded-lg mx-auto"
              />
              
              <p><strong>🌿 Participez à nos ateliers généalogiques</strong></p>
              <p>
              Envie de mieux connaître vos origines indiennes ?
              Nos ateliers sont là pour vous accompagner pas à pas dans la construction de votre arbre généalogique, avec l’aide de notre équipe.
              </p>

      
              <p><strong>🔍 Lors de ces ateliers, vous apprendrez à :</strong></p>
              <ul className="list-disc list-inside space-y-1">
                <li>Rechercher votre ancêtre indien</li>
                <li>Utiliser des logiciels simples et accessibles pour vos recherches</li>
              </ul>
      
              <p>📝  <strong>Pour participer, remplissez ce formulaire avec vos coordonnées.</strong><br />
              Nous vous contacterons pour vous informer des prochaines dates et lieux</p>
      
              <p><strong>🎁 La séance du 7 juin est offerte aux 10 premiers inscrits !</strong><br />
              Profitez-en vite, les places sont limitées.</p>
            </div>
      
            {/* Footer */}
            <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t border-gray-200 dark:border-neutral-800">
              <button
                type="button"
                className="py-2 px-3 inline-flex items-center gap-x-2 text-base font-bold rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none"
                onClick={() => setShowIntroModal(false)}
              >
                Commencer le formulaire
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Creneau;